// extracted by mini-css-extract-plugin
module.exports = {"contentwrapper":"ContentWrapper_contentwrapper__3NbmK"};